export default "__VITE_ASSET__zRWVumSR__"